import {
  Box,
  Flex,
  IconButton,
  StylesProvider,
  Text,
  useDisclosure,
  useMultiStyleConfig,
} from '@chakra-ui/react'
import { useEffect, useState } from 'react'

import { HelpDesk } from '../containers/HelpDesk'
import { useAuth } from '../context/AuthContext'
import { fetchOkKlientSpec } from '../hooks/useUser'
import { External, Help } from '../icons'
import { Container } from './Container'
import type { FooterProps } from './Footer'
import { FooterLink } from './Footer'

export const FooterCarkulka = ({
  sx,
  variant,
  hideLinks = false,
}: FooterProps) => {
  const styles = useMultiStyleConfig('Footer', { variant })
  const { isOpen, onOpen, onClose } = useDisclosure()

  const [isOkKlient, setIsOkKlient] = useState(false)

  //const { app } = useApp() //použít pokud budou linky závislé na aplikaci
  const { user } = useAuth() ?? {}
  const ouId = user?.ouId

  useEffect(() => {
    fetchOkKlientSpec().then((r) => setIsOkKlient(r.data.belongsToOkKlient))
  }, [ouId])

  let fotodokuLink = 'https://intranet.okgroup.cz/okg-informace/13664'
  let ppLink = 'https://intranet.okholding.cz/pp'

  if (isOkKlient) {
    fotodokuLink = 'https://intranet.okklient.cz/node/9535'
    ppLink = 'https://intranet.okklient.cz/pp-carkulka'
  }

  return (
    <Box __css={styles.footer} as="footer" sx={sx}>
      <StylesProvider value={styles}>
        <Container>
          <Box as="section" __css={styles.content}>
            <IconButton
              aria-label="HelpDesk"
              colorScheme="primary"
              sx={{
                position: 'fixed',
                p: 4,
                right: 4,
                bottom: { base: 20, xl: 4 },
                boxShadow: '3xl',
                borderRadius: 'full',
                zIndex: 'helpDeskButton',
              }}
              onClick={isOpen ? onClose : onOpen}
            >
              <Help color="white" width={8} height={8} />
            </IconButton>

            <HelpDesk isOpen={isOpen} onOpen={onOpen} onClose={onClose} />

            <Box sx={{ color: 'white', fontSize: 'xs' }}>
              <Text sx={{}}>
                <span>Provozovatel systému:</span> OK GROUP a.s., Mánesova
                3014/16, 612 00 Brno,
                <a href="mailto:carkulka@okholding.cz">carkulka@okholding.cz</a>
              </Text>
              <Text className="site-footer__text opacity-80">
                Copyright © OK GROUP a.s. 2023. Designed by ctyri.media.
                Developed by Cebia, s.r.o.
              </Text>
            </Box>

            {!hideLinks && (
              <Flex sx={{ gap: 1 }}>
                <FooterLink href={fotodokuLink}>
                  Fotodokumentace
                  <External />
                </FooterLink>

                <FooterLink href={ppLink}>
                  Pojistné podmínky
                  <External />
                </FooterLink>

                <FooterLink href="https://atlas.okholding.cz/tabulky/3">
                  Produktová srovnání
                  <External />
                </FooterLink>
              </Flex>
            )}
          </Box>
        </Container>
      </StylesProvider>
    </Box>
  )
}
